<template>
    <div>
        <Form :model="formData">
            <FormItem :label="$t('erp.b2corder.import_template', { defaultValue: '导入模板' })" :label-width="80" prop="templateId">
                <Select v-model="formData.templateId" @on-change="test">
                    <Option v-for="item in templateList" :value="item.id" :key="item.key">{{item.templateName}}</Option>
                </Select>
            </FormItem>
        </Form>
        <compUpload accept=".xls, .xlsx" v-bind="propsData" :data="uploadData" @on-success="uploadSuccess" @on-close="$emit('on-close')" @on-update="$emit('on-update')"></compUpload>
    </div>
</template>
<script>
import { HttpGetTemplate } from '@/service/boss/distribution.js';
export default {
    props: ["propsData"],
    components: {
        compUpload: () =>  import("@components/templates/upload"),
    },
    data () {
        return {
            formData: {
                templateId: 14
            },
            uploadData: {},
            templateList: []
        }
    },
    watch: {
        formData: {
            deep: true,
            handler (val) {
                this.uploadData = {
                ...this.propsData.data,
                templateId: this.formData.templateId
        }
            },
        }
    },
    created () {
        this.uploadData = {
            ...this.propsData.data,
            templateId: this.formData.templateId
        }
        HttpGetTemplate({
            templateType: 'SHIPMENTORDER'
        }).then(res => {
            this.templateList = res.data;
        }, err => {
            this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
        })
    },
    methods: {
        test (val) {
            console.log(this.formData.templateId);
        },
        uploadSuccess (res) {
            this.$VMessage.success(res.message);
        }
    }
}
</script>
